/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingDetailAttributeResponseDto } from './listingDetailAttributeResponseDto';
import type { ListingDetailOutdoorSpaceResponseDto } from './listingDetailOutdoorSpaceResponseDto';
import type { ListingDetailParkingSlotResponseDto } from './listingDetailParkingSlotResponseDto';
import type { ListingDetailResponseDtoApartmentConstructionType } from './listingDetailResponseDtoApartmentConstructionType';
import type { ListingDetailResponseDtoApartmentSubtype } from './listingDetailResponseDtoApartmentSubtype';
import type { ListingDetailResponseDtoEnergyPerformanceClass } from './listingDetailResponseDtoEnergyPerformanceClass';
import type { ListingDetailResponseDtoFurnishingType } from './listingDetailResponseDtoFurnishingType';
import type { ListingDetailResponseDtoHouseConstructionType } from './listingDetailResponseDtoHouseConstructionType';
import type { ListingDetailResponseDtoHouseSubtype } from './listingDetailResponseDtoHouseSubtype';
import type { ListingDetailResponseDtoLandReadiness } from './listingDetailResponseDtoLandReadiness';
import type { ListingDetailResponseDtoLandSubtype } from './listingDetailResponseDtoLandSubtype';
import type { ListingDetailResponseDtoOtherSubtype } from './listingDetailResponseDtoOtherSubtype';
import type { ListingDetailResponseDtoPropertyConditionType } from './listingDetailResponseDtoPropertyConditionType';
import type { ListingDetailResponseDtoRecreationalSubtype } from './listingDetailResponseDtoRecreationalSubtype';

export interface ListingDetailResponseDto {
  /** @nullable */
  apartmentSubtype: ListingDetailResponseDtoApartmentSubtype;
  /** @nullable */
  houseSubtype: ListingDetailResponseDtoHouseSubtype;
  /** @nullable */
  recreationalSubtype: ListingDetailResponseDtoRecreationalSubtype;
  /** @nullable */
  landSubtype: ListingDetailResponseDtoLandSubtype;
  /** @nullable */
  otherSubtype: ListingDetailResponseDtoOtherSubtype;
  /** @nullable */
  apartmentConstructionType: ListingDetailResponseDtoApartmentConstructionType;
  /** @nullable */
  houseConstructionType: ListingDetailResponseDtoHouseConstructionType;
  /** @nullable */
  propertyConditionType: ListingDetailResponseDtoPropertyConditionType;
  /** @nullable */
  buildingAge: string | null;
  /** @nullable */
  energyPerformanceClass: ListingDetailResponseDtoEnergyPerformanceClass;
  /** @nullable */
  furnishingType: ListingDetailResponseDtoFurnishingType;
  /** @nullable */
  monthlyUtilities: number | null;
  /** @nullable */
  floorNumber: number | null;
  /** @nullable */
  totalFloors: number | null;
  /** @nullable */
  roomCount: number | null;
  /** @nullable */
  usableArea: number | null;
  /** @nullable */
  landArea: number | null;
  /** @nullable */
  builtUpArea: number | null;
  parkingSlots: ListingDetailParkingSlotResponseDto[];
  /** @nullable */
  publicParkingPlaceCount: number | null;
  outdoorSpaces: ListingDetailOutdoorSpaceResponseDto[];
  attributes: ListingDetailAttributeResponseDto[];
  /** @nullable */
  landReadiness: ListingDetailResponseDtoLandReadiness;
}
